import { Box, styled } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';
import { MarkdownWrapper } from '../../MarkdownWrapper';
import { useRunOnce } from '../../useRunOnce';
import ExpandableText from '../../ExpandableText';
import { ArrowBendDownRight } from '@sweep-io/sweep-design/dist/icons';
import { extractDisplayText } from '../../../../utils/textWithIssueId';

export const AiChatUserMessageBox = ({
  content,
  onMount,
  replyTo,
}: {
  content: string | ReactNode;
  onMount?: () => void;
  replyTo?: string;
}) => {
  useRunOnce(() => {
    onMount?.();
  });

  return (
    <UserMessage data-message-type="user" className="user-message-box">
      {replyTo && <ReplyToMessage text={replyTo} />}
      <UserMessageBox>
        <MarkdownWrapper content={content} removeMargins={false} />
      </UserMessageBox>
    </UserMessage>
  );
};

const UserMessage = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  maxWidth: `max(70%, 396px)`,
  alignSelf: 'flex-end',
});

const UserMessageBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'flex-end',
  padding: '0 16px',
  borderRadius: '8px 8px 2px 8px',
  background: colors.grey[150],
});

const ReplyToMessage = ({ text }: { text: string }) => {
  // Remove issueId from display text while keeping it in the data for backend processing
  const displayText = extractDisplayText(text);

  return (
    <Box display="flex" gap="12px" className="user-message-reply-to">
      <Box flex="0 0 16px">
        <ArrowBendDownRight color={colors.grey[700]} />
      </Box>
      <Box>
        <ExpandableText rows={3} variant="caption" color={colors.grey[700]}>
          {displayText}
        </ExpandableText>
      </Box>
    </Box>
  );
};
